import * as z from 'zod';
import type { StorePreferencesConfig } from '@repo/utils';

const valueEntitySchema = z.object({
    key: z.string(),
    value: z.string(),
});

const preferenceSchema = z.object({
    name: z.optional(z.string()),
    type: z.optional(z.string()),
    value: z.string().or(z.array(valueEntitySchema)).or(z.array(z.string())).optional(),
});

export const storePreferencesConfigSchema = z.object({
    coworkerInfo: z.optional(z.object()),
    environment: z.optional(z.object()),
    preferences: z.optional(z.array(preferenceSchema)),
    storeCurrency: z.optional(z.string()),
});

export const isStorePreferencesConfig = (value: unknown): value is StorePreferencesConfig => {
    return storePreferencesConfigSchema.safeParse(value).success;
};
